import script from "./OnboardingChecklist.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingChecklist.vue?vue&type=script&lang=ts&setup=true"

import "./OnboardingChecklist.vue?vue&type=style&index=0&id=723799db&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723799db"]])

export default __exports__